<app-loader-page 
[isloading]="areTablesLoading$|async"
*ngIf="areTablesLoading$|async">
</app-loader-page>

<div *ngIf="!(areTablesLoading$|async)"  class="login-wrapper">
    <app-header [isNewRequest]="false"></app-header>

    <app-login-page (idFormFilled)="login($event)" *ngIf="!hasLoggedIn">
    </app-login-page>

    <app-otp [userId]="tz" *ngIf="hasLoggedIn">
    </app-otp>
</div>


// WEBPACK FOOTER //
// ./src/app/login/login.component.html